import { toast } from '@systemeio/ui'
import { RequestMethodsEnum, UseBaseFetchProps, getUseBaseFetch } from '@systemeio/util'
import { useRouter } from 'shared/hooks/use-router'
import { httpClient } from 'shared/utils/http-client'

const useBaseFetch = getUseBaseFetch({
  httpClient,
  useRouter,
  toast,
})

export const useFetch = <M extends RequestMethodsEnum, R = void, D = any, BadRequestError = any>(
  props: UseBaseFetchProps<R, M, BadRequestError>,
) => useBaseFetch<M, R, D, BadRequestError>(props)
